import React, { ReactNode } from 'react';

interface IProps {
  title: string;
  children: ReactNode;
  disabled: boolean;
  onSubmit: () => any;
  /** Conteúdo opcional exibido entre a logo e o título (ex.: mensagem de migração). */
  contentBetweenLogoAndTitle?: ReactNode;
}

export const AuthForm: React.FC<IProps> = ({
  title,
  children,
  disabled,
  onSubmit,
  contentBetweenLogoAndTitle
}) => (
  <form
    {...{
      className: 'auth-form',
      onSubmit: (evt) => {
        evt.preventDefault();

        if (disabled) {
          return;
        }

        onSubmit();
      }
    }}>
    <fieldset
      {...{
        disabled
      }}>
      <div className="logo">
        <img
          src="/assets/images/logo-email-new.png"
          alt="Fórum Conhecimento Jurídico"
        />
      </div>

      {contentBetweenLogoAndTitle}

      <h3 style={{ textAlign: 'center' }}>{title}</h3>

      {children}
    </fieldset>
  </form>
);
